import React, { useState } from 'react';

import Modal from '@components/common/Modal';
import SelectSpinnerModal from '@components/common/SelectSpinner/SelectSpinnerModal';
import Spinner from '@components/common/Spinner';

import { Icons } from '@icons/icons';

import { MODAL_WIDTH_580 } from '@constants/modals';

import Label from '../Label';

import styles from './SelectSpinner.module.scss';

interface ISelectSpinnerProps {
	selectedSpinnerId: number;
	selectedSpinnerColorId: number;
	setSelectedSpinnerColorId: (id: number) => void;
	setSelectedSpinnerId: (id: number) => void;
}

const SelectSpinner = ({
	selectedSpinnerId,
	selectedSpinnerColorId,
	setSelectedSpinnerColorId,
	setSelectedSpinnerId,
}: ISelectSpinnerProps) => {
	const [isSelectSpinnerModalOpen, setIsSelectSpinnerModalOpen] = useState(false);

	const openSelectSpinnerModal = () => setIsSelectSpinnerModalOpen(true);

	const closeSelectSpinnerModal = () => setIsSelectSpinnerModalOpen(false);

	return (
		<div className={styles.selectSpinnerContainer}>
			<Label
				className={styles.inputLabel}
				label='Spinner'
			/>
			<div
				className={styles.spinnerSelect}
				onClick={openSelectSpinnerModal}
			>
				<Spinner
					size={30}
					spinnerColorId={selectedSpinnerColorId}
					spinnerId={selectedSpinnerId}
				/>
				<div className={styles.chevronIcon}>
					{Icons.chevronDown()}
				</div>
			</div>
			<Modal
				isOpen={isSelectSpinnerModalOpen}
				onClose={closeSelectSpinnerModal}
				title='Select spinner'
				width={MODAL_WIDTH_580}
			>
				<SelectSpinnerModal
					closeModal={closeSelectSpinnerModal}
					prevSpinnerColorId={selectedSpinnerColorId}
					prevSpinnerId={selectedSpinnerId}
					proceedSpinnerColorId={setSelectedSpinnerColorId}
					proceedSpinnerId={setSelectedSpinnerId}
				/>
			</Modal>
		</div>
	);
};

export default SelectSpinner;
